import { Api } from '~/api/docs/app';
import { logger } from '~/consola/index';

const { api: appRequests, instance: { interceptors } } = new Api({
  baseURL: import.meta.env.VITE_APP_GATEWAY_URL as string,
  headers: {
    "x-api-key": import.meta.env.VITE_APP_APP_API_KEY as string,
  },
  timeout: 10000
});

interceptors.request.use(function (config) {
  logger.info(`REQUEST CONFIG: ${JSON.stringify(config)}`);
  return config;
}, function (error) {
  return Promise.reject(error);
});


interceptors.response.use(function (response) {
  logger.debug(`RESPONSE STATUS: ${response.status}`);
  return response;
}, function (error) {
  logger.error(`RESPONSE: ${JSON.stringify(error)}`);
  return Promise.reject(error);
});

export {
  appRequests
};